import { NgModule } from '@angular/core';
import { BlockUIModule } from 'ng-block-ui';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { MainComponent } from './main/main.component';
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr';
import { OverlayModule } from '@angular/cdk/overlay';
import { DecimalPipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { TfBlockUiComponent } from '@app/modules/tf-block-ui';
import { TfWindowRefService } from '@app/modules/tf-window-ref';
import { TfNotificationsModule, TfToastComponent } from '@app/modules/tf-notifications';
import { TfTooltipModule } from '@app/modules/tf-tooltip';
import { TfUserDataModule } from '@app/modules/tf-user-data';
import { TfPricingModule } from '@app/modules/tf-pricing';
import { TruncatePipe } from '@app/pipes/truncate.pipe';

@NgModule({
    declarations: [
        MainComponent,
        TruncatePipe
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        OverlayModule,
        HttpClientModule,
        ToastContainerDirective,
        ToastrModule.forRoot({
            toastComponent: TfToastComponent,
            closeButton: true,
            tapToDismiss: false
        }),
        TfNotificationsModule,
        TfUserDataModule,
        TfTooltipModule,
        TfPricingModule,
        BlockUIModule.forRoot({
            template: TfBlockUiComponent,
            delayStart: 50,
            delayStop: 50
        })
    ],
    providers: [
        TfWindowRefService,
        DecimalPipe
    ],
    bootstrap: [
        MainComponent
    ]
})
export class AppModule {
}
